import { enqueueSnackbar } from 'notistack';

const displaySuccessMessage = (message: string) => enqueueSnackbar(message, { variant: 'success' });

export default displaySuccessMessage;
